module.exports = __webpack_public_path__ + "img/LS.0badca26.svg";